import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Textbox } from './../../models/editors/textbox.model';
import { Social } from './../../models/social/social.model';

import { ApiService } from './../../shared/services/api.service';
import { FormControlService } from './../../shared/services/form-control.service';
import { AlertService } from './../../shared/services/alert.service';
import { Dropdown } from './../../models/editors/dropdown.model';
import { FormDetailBase } from './../../shared/components/base/form-detail/form-detail.base.component';

@Component({
  selector: 'swb-social-detail',
  templateUrl: './../../shared/components/base/form-detail/form-detail.base.component.html',
  providers: [FormControlService]
})
export class SocialDetailComponent extends FormDetailBase<Social> implements OnInit {

  private _options: { value: string, text: string }[] = [
    { value: 'facebook', text: 'facebook' },
    { value: 'facebook-square', text: 'facebook-square' },
    { value: 'facebook-f', text: 'facebook-f' },
    { value: 'instagram', text: 'instagram' },
    { value: 'linkedin', text: 'linkedin' },
    { value: 'linkedin-in', text: 'linkedin-in'},
    { value: 'google-plus', text: 'google-plus' },
    { value: 'google-plus-square', text: 'google-plus-square' },
    { value: 'youtube', text: 'youtube' },
    { value: 'youtube-square', text: 'youtube-square' },
    { value: 'vimeo', text: 'vimeo' },
    { value: 'twitter', text: 'twitter' },
    { value: 'tripadvisor', text: 'tripadvisor' },
    { value: 'slack', text: 'slack' },
    { value: 'tumblr', text: 'tumblr' },
    { value: 'slack', text: 'slack' },
    { value: 'skype', text: 'skype' },
    { value: 'medium', text: 'medium' },
    { value: 'pinterest', text: 'pinterest' }
  ];

  public url = 'socials';
  protected _redirect = './settings';

  public get fieldsConfig(): Array<any> {
    return [
      new Textbox({
        key: 'link',
        label: 'Odkaz',
        isMultilang: true
      }),
      new Dropdown({
        key: 'icon',
        label: 'Ikona',
        options: this._options,
        iconTemplate: true
      })
    ];
  }
  constructor(
    _formService: FormControlService,
    _apiService: ApiService,
    _router: Router,
    _alertService: AlertService,
    private _route: ActivatedRoute
  ) {
    super(
      _formService,
      _apiService,
      _router,
      _alertService
    );
  }


  ngOnInit() {

    if (typeof this._route.snapshot.params['id'] !== 'undefined') {
      this._id = this._route.snapshot.params['id'];
    }

    this._getEntity();
  }

}
